import { Breakpoint, Color, FontWeight, Markdown, StyledComponent } from '@on-arte/ui';
import styled from 'styled-components';

export const MarkdownContainer: StyledComponent<'div'> = styled.div`
  & + & {
    margin-top: 40px;
  }
`;

export const Header: StyledComponent<typeof Markdown> = styled(Markdown)`
  font-weight: ${FontWeight.Medium};
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.01em;
  color: ${Color.Black};
  display: inline-block;
  margin-bottom: 24px;
`;

export const Content: StyledComponent<'div'> = styled.div`
  p {
    font-weight: ${FontWeight.Light};
    font-size: 16px;
    line-height: 22px;
    color: ${Color.Black};
    margin-bottom: 24px;
  }

  a {
    color: ${Color.Black};
    text-decoration-line: underline;
    font-weight: ${FontWeight.Medium};
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  img {
    padding: 20px 0;
    display: block;

    @media ${Breakpoint.SmallMobile} {
      max-width: 280px;
    }
  }

  ol, ul {
    list-style-position: inside;
    margin-bottom: 24px;

    li {
      font-weight: ${FontWeight.Light};
      font-size: 16px;
      line-height: 22px;
      color: ${Color.Black};
      margin-top: 4px;
    }
  }

  table {
    width: 100%;
    border: 1px solid ${Color.Gray200};
    margin-bottom: 24px;

    th {
      background-color: ${Color.Gray100};
    }

    th, td {
      width: 50%;
      border-right: 1px solid ${Color.Gray200};
      border-bottom: 1px solid ${Color.Gray200};
      text-align: left;
      padding: 10px;
    }
  }
`;
